import { render, staticRenderFns } from "./empty-user.vue?vue&type=template&id=34410206&scoped=true&"
import script from "./empty-user.vue?vue&type=script&lang=js&"
export * from "./empty-user.vue?vue&type=script&lang=js&"
import style0 from "./empty-user.vue?vue&type=style&index=0&id=34410206&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34410206",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/builds/master/frontend/frontend-universe/components/SvgIcon.vue').default})
